'use client';

import { Backdrop, Box, CircularProgress } from '@mui/material';
import '../../styles/page.css';

const Loader = () => {
  return (
    <>
      <Backdrop open className="backdrop">
        <Box className="loader">
          <CircularProgress color="inherit" />
        </Box>
      </Backdrop>
    </>
  );
};

export default Loader;
